import React from "react";

import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import { Warning as WarningIcon, CheckCircle as SuccessIcon, Error as ErrorIcon, CancelOutlined } from "@mui/icons-material";
import useGlobal from "../../util/Global";
import CheckIcon from '@mui/icons-material/Check';

const iconMap = {
    warning: WarningIcon,
    success: SuccessIcon,
    error: ErrorIcon,
};

const colorMap = {
    warning: '#ecbd13',
    success: '#09400a',
    error: "red",
};

const OptionDialog = ({
    open,
    onClose,
    onConfirm,
    message = 'message.areYouSureAction',
    title = "title.confirmDialogTitle",
    isGlobal = true,
    confirmLabel = "button.confirm",
    cancelLabel = 'button.cancel',
    confirmColor = "primary",
    cancelColor = "danger",
    variant = "warning", // Can be: "warning", "success", "error"
    loading,
    icon, // Custom icon prop
    bodyContain
}) => {
    const IconComponent = iconMap[variant] || WarningIcon;
    const iconColor = colorMap[variant] || "info";

    const { t } = useGlobal();

    const popContains = bodyContain ?? (isGlobal == true ? t(message) : message);


    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth="sm"
            scroll="paper"
            onClose={!loading ? onClose : null}  // Prevent closing the dialog while loading
            disableEscapeKeyDown={loading}  // Disable escape key when loading
        >
            <DialogTitle>
                {icon ? (
                    icon
                ) : (
                    <IconComponent sx={{ marginRight: 3, verticalAlign: "middle", color: iconColor }} />
                )}
                {isGlobal == true ? t(title) : title}
            </DialogTitle>
            <DialogContent dividers={true}>
                <div style={{ padding: '6px 0' }}>
                    {popContains}
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color={cancelColor} startIcon={<CancelOutlined />} disabled={loading}>
                    {t(cancelLabel)}
                </Button>
                <Button onClick={onConfirm} color={confirmColor} startIcon={<CheckIcon />} autoFocus>
                    {t(confirmLabel)}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default OptionDialog;
